import React, { useState, useEffect } from 'react';
import { Container, Paper, TextField, Button, Box, FormControlLabel, Checkbox, MenuItem, Alert } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../api/axiosConfig';

const ProgramaForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const user = localStorage.getItem('user');

  const [formData, setFormData] = useState({
    id_sector: '',
    codigo: '',
    descripcion: '',
    unidad_ejecutora: '',
    responsable: '',
    observaciones: '',
    activo: true,
  });
  const [sectores, setSectores] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    api.get('/sectores/').then(res => setSectores(res.data));
  }, []);

  useEffect(() => {
    if (id) {
      api.get(`/programas/${id}/`).then(res => setFormData(res.data));
    }
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const payload = {
      ...formData,
      creado_por: user,
      modificado_por: user,
    };

    try {
      if (id) {
        await api.put(`/programas/${id}/`, { ...formData, modificado_por: user });
      } else {
        await api.post('/programas/', payload);
      }
      navigate('/programas');
    } catch (err) {
      setError('Error al guardar el programa');
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="md">
      <Paper sx={{ p: 3, mt: 3 }}>
        <Box component="form" onSubmit={handleSubmit}>
          <TextField
            select
            label="Sector *"
            fullWidth
            value={formData.id_sector}
            onChange={(e) => setFormData({ ...formData, id_sector: e.target.value })}
            margin="normal"
            required
          >
            {sectores.map(sec => (
              <MenuItem key={sec.id_sector} value={sec.id_sector}>
                {sec.codigo} - {sec.descripcion}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            label="Código *"
            fullWidth
            value={formData.codigo}
            onChange={(e) => setFormData({ ...formData, codigo: e.target.value })}
            margin="normal"
            required
          />
          <TextField
            label="Descripción *"
            fullWidth
            value={formData.descripcion}
            onChange={(e) => setFormData({ ...formData, descripcion: e.target.value })}
            margin="normal"
            required
          />
          <TextField
            label="Unidad Ejecutora"
            fullWidth
            value={formData.unidad_ejecutora}
            onChange={(e) => setFormData({ ...formData, unidad_ejecutora: e.target.value })}
            margin="normal"
          />
          <TextField
            label="Responsable"
            fullWidth
            value={formData.responsable}
            onChange={(e) => setFormData({ ...formData, responsable: e.target.value })}
            margin="normal"
          />
          <TextField
            label="Observaciones"
            fullWidth
            multiline
            rows={3}
            value={formData.observaciones}
            onChange={(e) => setFormData({ ...formData, observaciones: e.target.value })}
            margin="normal"
          />
          <FormControlLabel
            control={<Checkbox checked={formData.activo} onChange={(e) => setFormData({ ...formData, activo: e.target.checked })} />}
            label="Activo"
          />
          {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
          <Box sx={{ mt: 2 }}>
            <Button type="submit" variant="contained" disabled={loading} sx={{ mr: 1 }}>
              {loading ? 'Guardando...' : id ? 'Actualizar' : 'Crear'}
            </Button>
            <Button onClick={() => navigate('/programas')}>Cancelar</Button>
          </Box>
        </Box>
      </Paper>
    </Container>
  );
};

export default ProgramaForm;